import {IPoint} from '@consts/types';
import React, { FC, useCallback, useMemo } from 'react';
import { SoundMatrix} from '@common/launchpad';
import {
  MatrixContainer,
  MatrixRow,
  MatrixCell
} from '../styleds/matrix';

interface IMatrixProps {
  activeCell: IPoint[];
  matrix: SoundMatrix;
  schemeKey: string;
  onToggleCell: (position: IPoint) => void;
}

interface IActiveCellMap {
  [row: number]: {
    [cell: number]: number
  }
}

const LaunchpadMatrix: FC<IMatrixProps> = ({
    matrix,
    activeCell,
    schemeKey,
    onToggleCell
}) => {
  const orderMap = useMemo(() => {
    const keyMap = new Array(matrix.length).fill(null).map((_, i) => [i, {}]);
    const map: IActiveCellMap = Object.fromEntries(keyMap);
    return activeCell.reduce((obj, { x, y }, index) => {
      obj[y][x] = index + 1;
      return obj;
    }, map)
  }, [activeCell, matrix]);

  const isCellSelect = useCallback(
    (x: number, y: number) => !!orderMap[y][x],
    [orderMap]
  )

  const onCellClick = useCallback((x: number, y: number) => {
    onToggleCell({ x, y });
  }, [onToggleCell])

  return (
    <MatrixContainer>
      {matrix.map((row, rowIndex) => (
        <MatrixRow key={`${schemeKey}-${rowIndex}`}>
          {row.map((cell, cellIndex) => (
            <MatrixCell
              key={`${schemeKey}-${rowIndex}:${cellIndex}`}
              isSelect={isCellSelect(cellIndex, rowIndex)}
              color={cell.color}
              onClick={() => onCellClick(cellIndex, rowIndex)}
            >
              {cell.nodeName}
            </MatrixCell>
          ))}
        </MatrixRow>
      ))}
    </MatrixContainer>
  )
}

export default LaunchpadMatrix;
